import { Receipt, Mail, Key, Building2 } from "lucide-react";

export default function ActivationProcessSection() {
  const steps = [
    {
      icon: Receipt,
      title: "Nota fiscal emitida após confirmação",
      description: "NFe gerada e enviada por e-mail após confirmação do pagamento",
    },
    {
      icon: Mail,
      title: "Chave de ativação por e-mail",
      description: "Receba sua chave exclusiva em minutos após o pagamento",
    },
    {
      icon: Building2,
      title: "Licença vinculada ao CNPJ",
      description: "Sua licença é registrada no CNPJ da sua empresa",
    },
    {
      icon: Key,
      title: "Vinculada ao dispositivo",
      description: "Ativação única por máquina para segurança total",
    },
  ];

  return (
    <section
      id="activation-process"
      className="relative py-16 md:py-32 bg-[#0A0B0E]"
      data-testid="activation-process-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Pós-Pagamento
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            Processo de <span className="text-[#F59E0B]">Ativação</span>
          </h2>
        </div>

        {/* Intro Text */}
        <div className="text-center mb-12">
          <p className="text-[#9CA3AF] text-base md:text-lg">
            Após confirmação de pagamento:
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-6 bg-[#1C1F26] border border-[#2A2F38] rounded-sm hover:border-[#F59E0B]/50 transition-all"
              data-testid={`activation-step-${index}`}
            >
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#0E3A46] rounded-sm">
                <step.icon className="h-6 w-6 text-[#F59E0B]" />
              </div>
              <div>
                <h3 className="font-heading text-lg font-bold text-[#E5E7EB] mb-1">
                  {step.title}
                </h3>
                <p className="text-sm text-[#9CA3AF]">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
